import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getStudentCounsels, createStudentCounsel, updateStudentCounsel } from '../api/studentsCounsel.api';
import { ICounsel, ICounselReq, IGetCounsels } from '../models/studentsCounsel.model';

interface ICounselState {
  studentCounsels: ICounsel[];
  isLoading: boolean;
  error?: AxiosError | string;
};

const initialState: ICounselState = {
  studentCounsels: [],
  isLoading: false
};

const studentCounselSlicer = createSlice({
  name: 'studentCounsel',
  initialState,
  reducers: {
    getCounselsStart: (state: ICounselState) => {
      state.studentCounsels = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getCounselsSuccess: (state: ICounselState, action: PayloadAction<IGetCounsels>) => {
      state.studentCounsels = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getCounselsFailure: (state: ICounselState, action: PayloadAction<AxiosError|string>) => {
      state.studentCounsels = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: ICounselState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (state: ICounselState, action: PayloadAction<AxiosError|string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSuccess: (state: ICounselState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    updateSuccess: (state: ICounselState) => {
      state.isLoading = false;
      state.error = undefined;
    }
  }
});

export const {
  getCounselsStart,
  getCounselsSuccess,
  getCounselsFailure,
  requestStart,
  requestFailure,
  createSuccess,
  updateSuccess,
} = studentCounselSlicer.actions;

export default studentCounselSlicer.reducer;

export const doGetStudentCounsels = (memberCode: string, campusCode: string): any => async (dispatch: any) => {
  try {
    dispatch(getCounselsStart());
    const response = await getStudentCounsels(memberCode, campusCode);
    dispatch(getCounselsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getCounselsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doCreateStudentCounsel = (memberCode: string, campusCode: string, data: ICounselReq): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await createStudentCounsel(memberCode, campusCode, data);
    dispatch(createSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doUpdateStudentCounsel = (counselCode: number, data: ICounselReq): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await updateStudentCounsel(counselCode, data);
    dispatch(updateSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
